import React, { useEffect, useState } from "react";
import { axInst, axInstBasic } from "../Service/Service";

// const fetchTotalOpenJC = async (isSearchArn) => {
//   const basicAuth =
//     "Basic " +
//     btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);
//   try {
//     const res = await axInst.post(
//       `${process.env.REACT_APP_API_URL}allOpenJC`,
//       { isSearchArn },
//       // {
//       //   headers: {
//       //     Authorization: basicAuth,
//       //   },
//       // }
//     );
//     return res.data.result;
//   } catch (error) {
//     console.error(error);
//     throw error;
//   }
// };

export const fetchTotalOpenJC = async (isSearchArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}allOpenJC`,{isSearchArn}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// const fetchOpenJCDayWise = async (isSearchArn) => {
//   const basicAuth =
//     "Basic " +
//     btoa(`${process.env.REACT_APP_UNAME}:${process.env.REACT_APP_PWD}`);
//   try {
//     const res = await axInst.post(
//       `${process.env.REACT_APP_API_URL}openJCforDays`,
//       { isSearchArn },
//       {
//         headers: {
//           Authorization: basicAuth,
//         },
//       }
//     );
//     return res.data.result;
//   } catch (error) {
//     console.error(error);
//     throw error;
//   }
// };

export const fetchOpenJCDayWise = async (isSearchArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}openJCforDays`,{isSearchArn}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

function Card({ isSearchArn, isArn, setIsSearchArn, isWaterMark }) {
  const [totalOpenJCData, setTotalOpenJCData] = useState(null);
  const [dayWiseOpenJCData, setDayWiseOpenJCData] = useState(null);
  const [isWaterMarkData, setIsWaterMarkData] = useState(null);

  useEffect(() => {
    if (isSearchArn && isArn) {
      fetchTotalOpenJC(isArn)
        .then((data) => {
          setTotalOpenJCData(data);
        })
        .catch((error) => {
          console.error("Error fetching total open JC:", error);
        });
      fetchOpenJCDayWise(isArn)
        .then((data) => {
          setDayWiseOpenJCData(data);
        })
        .catch((error) => {
          console.error("Error fetching open JC day-wise data:", error);
        });
    }
    setIsSearchArn(false);
  }, [isSearchArn, isArn, setIsSearchArn]);

  useEffect(() => {
    setIsWaterMarkData(isWaterMark);
  }, [isWaterMark]);

  const convertedObject = totalOpenJCData
    ? totalOpenJCData.reduce((acc, curr) => {
        acc[curr.key] = curr.doc_count;
        return acc;
      }, {})
    : {};
  const totalCountTodayOpen =
    dayWiseOpenJCData?.["JC Created Today & Open"]?.total_count ?? 0;
  const mechanicalTodayOpen =
    dayWiseOpenJCData?.["JC Created Today & Open"]?.service_types?.MECHANICAL ??
    0;
  const accidentalTodayOpen =
    dayWiseOpenJCData?.["JC Created Today & Open"]?.service_types?.ACCIDENTAL ??
    0;

  const totalCount1_3 =
    dayWiseOpenJCData?.["A : 1 To 3 Days"]?.total_count ?? 0;
  const mechanicalCount1_3 =
    dayWiseOpenJCData?.["A : 1 To 3 Days"]?.service_types?.MECHANICAL ?? 0;
  const accidentalCount1_3 =
    dayWiseOpenJCData?.["A : 1 To 3 Days"]?.service_types?.ACCIDENTAL ?? 0;
  const totalCount4_7 =
    dayWiseOpenJCData?.["B : 4 To 7 Days"]?.total_count ?? 0;
  const mechanicalCount4_7 =
    dayWiseOpenJCData?.["B : 4 To 7 Days"]?.service_types?.MECHANICAL ?? 0;
  const accidentalCount4_7 =
    dayWiseOpenJCData?.["B : 4 To 7 Days"]?.service_types?.ACCIDENTAL ?? 0;
  const totalCount8_15 =
    dayWiseOpenJCData?.["C : 8 To 15 Days"]?.total_count ?? 0;
  const mechanicalCount8_15 =
    dayWiseOpenJCData?.["C : 8 To 15 Days"]?.service_types?.MECHANICAL ?? 0;
  const accidentalCount8_15 =
    dayWiseOpenJCData?.["C : 8 To 15 Days"]?.service_types?.ACCIDENTAL ?? 0;
  const totalCount16 =
    dayWiseOpenJCData?.["D : 16 To 30 Days"]?.total_count ?? 0;
  const mechanicalCount16 =
    dayWiseOpenJCData?.["D : 16 To 30 Days"]?.service_types?.MECHANICAL ?? 0;
  const accidentalCount16 =
    dayWiseOpenJCData?.["D : 16 To 30 Days"]?.service_types?.ACCIDENTAL ?? 0;

  return (
    <>
      <div className="md:grid block sm:grid-cols-1 grid-cols-6 md:grid-cols-6 lg:grid-cols-6 gap-2 mb-0">
        <div className="relative bg-gradient-to-b from-[#FE875D] to-[#FD4D90] text-white p-2 shadow-lg rounded-md md:mb-0 mb-2 h-24">
          {isWaterMarkData && (
            <div className="absolute inset-0 flex flex-col items-center justify-center opacity-25 text-1xl text-center z-[100000]">
              <div>{isWaterMarkData.userId}</div>
              <div>{isWaterMarkData.date}</div>
              <div>{isWaterMarkData.ip}</div>
            </div>
          )}
          <div className="flex justify-between items-center mb-2 border-b border-gray-200">
            <div className="text-xl font-bold">
              {(convertedObject.MECHANICAL || 0) +
                (convertedObject.ACCIDENTAL || 0)}
            </div>
            <div className="text-[15px] ml-2">Total Open JCs</div>
          </div>
          <div className="flex justify-between">
            {/* Mechanical Section */}
            <div className="flex-1 pr-2 border-r border-gray-300">
              <div className="text-lg">
                {convertedObject.MECHANICAL ? convertedObject.MECHANICAL : 0}
              </div>
              <div className="text-sm text-white-800">Mechanical</div>
            </div>
            {/* Accidental Section */}
            <div className="flex-1 pl-2 text-right">
              <div className="text-lg">
                {convertedObject.ACCIDENTAL ? convertedObject.ACCIDENTAL : 0}
              </div>
              <div className="text-sm text-white-800">Accidental</div>
            </div>
          </div>
        </div>

        {/* New Card */}
        <div className="relative bg-gradient-to-b from-[#FEC46D] to-[#FD8A4A] text-white p-2 shadow-lg rounded-md md:mb-0 mb-2 h-24">
          {isWaterMarkData && (
            <div className="absolute inset-0 flex flex-col items-center justify-center opacity-25 text-1xl text-center z-[100000]">
              <div>{isWaterMarkData.userId}</div>
              <div>{isWaterMarkData.date}</div>
              <div>{isWaterMarkData.ip}</div>
            </div>
          )}
          {/* <div className="text-xl font-bold">{totalCountTodayOpen}</div>
          <div className="text-[15px]">JC created today and open</div> */}
          <div className="flex justify-between items-center mb-2 border-b border-gray-200">
            <div className="text-xl font-bold">{totalCountTodayOpen}</div>
            <div className="text-[15px] ml-2">JC Open today</div>
          </div>
          <div className="flex justify-between">
            <div className="flex-1 pr-2 border-r border-gray-300">
              <div className="text-lg">{mechanicalTodayOpen}</div>
              <div className="text-sm text-white-800">Mechanical</div>
            </div>
            <div className="flex-1 pl-2 text-right">
              <div className="text-lg">{accidentalTodayOpen}</div>
              <div className="text-sm text-white-800">Accidental</div>
            </div>
          </div>
        </div>
        <div className="relative bg-gradient-to-b from-[#00E0FE] to-[#0181D1] text-white p-2 shadow-lg rounded-md md:mb-0 mb-2 h-24">
          {isWaterMarkData && (
            <div className="absolute inset-0 flex flex-col items-center justify-center opacity-25 text-1xl text-center z-[100000]">
              <div>{isWaterMarkData.userId}</div>
              <div>{isWaterMarkData.date}</div>
              <div>{isWaterMarkData.ip}</div>
            </div>
          )}
          {/* <div className="text-xl font-bold">{totalCount1_3}</div>
          <div className="text-[15px]">Open for 1-3 Days</div> */}
          <div className="flex justify-between items-center mb-2 border-b border-gray-200">
            <div className="text-xl font-bold">{totalCount1_3}</div>
            <div className="text-[15px] ml-2">Open for 1-3 Days</div>
          </div>
          <div className="flex justify-between ">
            <div className="flex-1 pr-2 border-r border-gray-300">
              <div className="text-lg">{mechanicalCount1_3}</div>
              <div className="text-sm text-white-800">Mechanical</div>
            </div>
            <div className="flex-1 pl-2 text-right">
              <div className="text-lg">{accidentalCount1_3}</div>
              <div className="text-sm text-white-800">Accidental</div>
            </div>
          </div>
        </div>

        <div className="relative bg-gradient-to-b from-[#55e8a1] to-[#169357] text-white p-2 shadow-lg rounded-md md:mb-0 mb-2 h-24">
          {isWaterMarkData && (
            <div className="absolute inset-0 flex flex-col items-center justify-center opacity-25 text-1xl text-center z-[100000]">
              <div>{isWaterMarkData.userId}</div>
              <div>{isWaterMarkData.date}</div>
              <div>{isWaterMarkData.ip}</div>
            </div>
          )}
          {/* <div className="text-xl font-bold">{totalCount4_7}</div>
          <div className="text-[15px]">Open for 4-7 Days</div> */}
          <div className="flex justify-between items-center mb-2 border-b border-gray-200">
            <div className="text-xl font-bold">{totalCount4_7}</div>
            <div className="text-[15px] ml-2">Open for 4-7 Days</div>
          </div>
          <div className="flex justify-between ">
            <div className="flex-1 pr-2 border-r border-gray-300">
              <div className="text-lg">{mechanicalCount4_7}</div>
              <div className="text-sm text-white-800">Mechanical</div>
            </div>
            <div className="flex-1 pl-2 text-right">
              <div className="text-lg">{accidentalCount4_7}</div>
              <div className="text-sm text-white-800">Accidental</div>
            </div>
          </div>
        </div>
        <div className="relative bg-gradient-to-b from-[#EF6AE9] to-[#8463FA] text-white p-2 shadow-lg rounded-md md:mb-0 mb-2 h-24">
          {isWaterMarkData && (
            <div className="absolute inset-0 flex flex-col items-center justify-center opacity-25 text-1xl text-center z-[100000]">
              <div>{isWaterMarkData.userId}</div>
              <div>{isWaterMarkData.date}</div>
              <div>{isWaterMarkData.ip}</div>
            </div>
          )}
          {/* <div className="text-xl font-bold">{totalCount8_15}</div>
          <div className="text-[15px]">Open for 8-15 Days</div> */}
          <div className="flex justify-between items-center mb-2 border-b border-gray-200">
            <div className="text-xl font-bold">{totalCount8_15}</div>
            <div className="text-[15px] ml-2">Open for 8-15 Days</div>
          </div>
          <div className="flex justify-between ">
            <div className="flex-1 pr-2 border-r border-gray-300">
              <div className="text-lg">{mechanicalCount8_15}</div>
              <div className="text-sm text-white-800">Mechanical</div>
            </div>
            <div className="flex-1 pl-2 text-right">
              <div className="text-lg">{accidentalCount8_15}</div>
              <div className="text-sm text-white-800">Accidental</div>
            </div>
          </div>
        </div>
        <div className="relative bg-gradient-to-b from-[#3CD0C0] to-[#129BD2] text-white p-2 shadow-lg rounded-md md:mb-0 mb-2 h-24">
          {isWaterMarkData && (
            <div className="absolute inset-0 flex flex-col items-center justify-center opacity-25 text-1xl text-center z-[100000]">
              <div>{isWaterMarkData.userId}</div>
              <div>{isWaterMarkData.date}</div>
              <div>{isWaterMarkData.ip}</div>
            </div>
          )}
          {/* <div className="text-xl font-bold">{totalCount16}</div>
          <div className="text-[15px]">Open Beyond 15 Days</div> */}
          <div className="flex justify-between items-center mb-2 border-b border-gray-200">
            <div className="text-xl font-bold">{totalCount16}</div>
            <div className="text-[15px] ml-2">Open Beyond 15 Days</div>
          </div>
          <div className="flex justify-between ">
            <div className="flex-1 pr-2 border-r border-gray-300">
              <div className="text-lg">{mechanicalCount16}</div>
              <div className="text-sm text-white-800">Mechanical</div>
            </div>
            <div className="flex-1 pl-2 text-right">
              <div className="text-lg">{accidentalCount16}</div>
              <div className="text-sm text-white-800">Accidental</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Card;
